import * as React from 'react';
export const emailSvg = React.forwardRef(function emailSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.75 10.762a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3 1.512a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3H3Zm10 1.5H3a1.5 1.5 0 0 0-1.307.763c.055.015.11.036.162.065l6.026 3.244a.25.25 0 0 0 .237 0l6.026-3.244a.752.752 0 0 1 .163-.065A1.5 1.5 0 0 0 13 3.012Zm1.5 2.34L8.83 8.405a1.75 1.75 0 0 1-1.66 0L1.5 5.352v6.16a1.5 1.5 0 0 0 1.5 1.5h10a1.5 1.5 0 0 0 1.5-1.5v-6.16Z',
    }),
  );
});
emailSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var email = {
  category: 'icon',
  colorable: true,
  name: 'email',
  svg: emailSvg,
};
